import React from 'react';
import QuotesIcon from '@assets/images/app/icon-quotes@3x.png';
import { ProductModel } from '@models/product';
import { cdnImageUrl } from '@utils/image';

export const ClassIntroduction: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;
  const detailImage =
    (data?.classIntroductionImageTemp || data.classIntroductionImage) === null
      ? null
      : data?.classIntroductionImageTemp || data.classIntroductionImage || data?.detailImages?.[0];

  return (
    <div style={{ marginTop: '16px', paddingLeft: '16px', paddingRight: '16px' }}>
      <div
        style={{
          marginBottom: '10px',
          color: '#FF3D8F',
          fontSize: '18px',
          fontFamily: 'Glory',
          fontWeight: '800',
          lineHeight: '18px',
        }}>
        ABOUT
      </div>
      <div
        style={{
          color: '#242424',
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '26px',
        }}>
        무엇을 경험하나요?
      </div>
      {detailImage && (
        <div style={{ marginTop: '24px' }}>
          <img
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
            }}
            src={cdnImageUrl(detailImage)}
            alt=""
          />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          position: 'relative',
          marginTop: '46px',
          marginBottom: '40px',
          borderRadius: '8px',
          paddingTop: '28px',
          paddingBottom: '20px',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          paddingLeft: '20px',
          paddingRight: '20px',
          border: '1px solid #e8eaed',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '60px',
            backgroundColor: '#ffffff',
            position: 'absolute',
            top: '-8px',
          }}>
          <img style={{ width: '22px', height: '16px' }} src={QuotesIcon} alt="" />
        </div>
        <div
          style={{
            display: 'flex',
            fontSize: '18px',
            lineHeight: '28px',
            color: '#424242',
            textAlign: 'center',
            flexWrap: 'wrap',
          }}>
          {data?.title}
        </div>
        <div style={{ fontSize: '14px', color: '#808387', marginTop: '8px' }}>by. {data?.sellerName}</div>
      </div>

      {(data?.details?.introductions || []).map((item: { title?: string; description?: string }, index: number) => {
        return (
          <div
            key={`intro-${index}`}
            style={{
              marginBottom: data?.details?.introductions?.length === index + 1 ? 0 : '40px',
            }}>
            {item.title && item.title !== '' && (
              <div
                style={{
                  fontSize: '18px',
                  lineHeight: '24px',
                  color: '#242424',
                  fontWeight: 'bold',
                  marginBottom: '12px',
                }}>
                {item.title}
              </div>
            )}
            {item.description && item.description !== '' && (
              <div
                style={{
                  fontSize: '16px',
                  color: '#424242',
                  lineHeight: '28px',
                  letterSpacing: -0.4,
                }}>
                {item.description.split('\n').map((line, index2) => {
                  if (line && line !== '' && line[0] === '-') {
                    line = line.replace('-', '• ');
                  }

                  return (
                    <div key={`description-${index2}`} style={{ whiteSpace: 'pre-wrap' }}>
                      {line}
                      {(item?.description || '').split('\n').length - 1 === index2 ? '' : '\n'}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
